module.exports = __webpack_public_path__ + "about-us-b998e096/503-4047d3143a02e6fe213c64b20551cbdf.svg";